module.exports = __webpack_public_path__ + "img/CornershopNew.408bf198.png";